// Villages data
export const villages = [
    {
        villageId: 1,
        villageName: "산청마을",
        sidoName: "경상남도",
        sigunguName: "산청군",
        address: "경상남도 산청군 산청읍 산청리 123",
        phoneNumber: "055-123-4567",
        latitude: 35.415,
        longitude: 127.875,
        programName: "한방약초채취체험",
        programContent: "농작물경작체험",
        imageUrl: "https://picsum.photos/800/600?random=11",
    },
    {
        villageId: 2,
        villageName: "두리마을",
        sidoName: "전라북도",
        sigunguName: "남원시",
        address: "전라북도 남원시 두리길 45",
        phoneNumber: "063-234-5678",
        latitude: 35.416,
        longitude: 127.390,
        programName: "세상에단하나뿐인나만의도자기",
        programContent: "만들기체험",
        imageUrl: "https://picsum.photos/800/600?random=12",
    },
    {
        villageId: 3,
        villageName: "해맞이마을",
        sidoName: "강원도",
        sigunguName: "강릉시",
        address: "강원도 강릉시 해안로 789",
        phoneNumber: "033-345-6789",
        latitude: 37.751,
        longitude: 128.876,
        programName: "바다낚시체험",
        programContent: "자연생태체험",
        imageUrl: "https://picsum.photos/800/600?random=13",
    },
    {
        villageId: 4,
        villageName: "별빛마을",
        sidoName: "경기도",
        sigunguName: "가평군",
        address: "경기도 가평군 별빛로 234",
        phoneNumber: "031-456-7890",
        latitude: 37.831,
        longitude: 127.509,
        programName: "천문대별자리관측",
        programContent: "자연생태체험",
        imageUrl: "https://picsum.photos/800/600?random=14",
    },
    {
        villageId: 5,
        villageName: "옹기마을",
        sidoName: "경상북도",
        sigunguName: "영천시",
        address: "경상북도 영천시 옹기촌길 567",
        phoneNumber: "054-567-8901",
        latitude: 35.973,
        longitude: 128.939,
        programName: "전통옹기제작",
        programContent: "만들기체험",
        imageUrl: "https://picsum.photos/800/600?random=15",
    },
    {
        villageId: 6,
        villageName: "녹차마을",
        sidoName: "전라남도",
        sigunguName: "보성군",
        address: "전라남도 보성군 녹차밭길 890",
        phoneNumber: "061-678-9012",
        latitude: 34.771,
        longitude: 127.080,
        programName: "녹차따기체험",
        programContent: "농작물경작체험",
        imageUrl: "https://picsum.photos/800/600?random=16",
    },
    {
        villageId: 7,
        villageName: "한옥마을",
        sidoName: "전라북도",
        sigunguName: "전주시",
        address: "전라북도 전주시 완산구 한옥마을길 12",
        phoneNumber: "063-789-0123",
        latitude: 35.815,
        longitude: 127.153,
        programName: "한옥스테이",
        programContent: "전통문화체험",
        imageUrl: "https://picsum.photos/800/600?random=17",
    },
    {
        villageId: 8,
        villageName: "사과마을",
        sidoName: "충청북도",
        sigunguName: "충주시",
        address: "충청북도 충주시 사과나무길 345",
        phoneNumber: "043-890-1234",
        latitude: 36.991,
        longitude: 127.926,
        programName: "사과수확체험",
        programContent: "농작물경작체험",
        imageUrl: "https://picsum.photos/800/600?random=18",
    },
    {
        villageId: 9,
        villageName: "DMZ생태마을",
        sidoName: "경기도",
        sigunguName: "파주시",
        address: "경기도 파주시 DMZ로 678",
        phoneNumber: "031-901-2345",
        latitude: 37.899,
        longitude: 126.780,
        programName: "DMZ생태탐방",
        programContent: "자연생태체험",
        imageUrl: "https://picsum.photos/800/600?random=19",
    },
    {
        villageId: 10,
        villageName: "올레길마을",
        sidoName: "제주특별자치도",
        sigunguName: "서귀포시",
        address: "제주특별자치도 서귀포시 올레길 901",
        phoneNumber: "064-012-3456",
        latitude: 33.254,
        longitude: 126.560,
        programName: "올레길트레킹",
        programContent: "건강",
        imageUrl: "https://picsum.photos/800/600?random=20",
    },
    {
        villageId: 11,
        villageName: "산촌체험마을",
        sidoName: "강원도",
        sigunguName: "홍천군",
        address: "강원도 홍천군 산촌로 234",
        phoneNumber: "033-123-4567",
        latitude: 37.697,
        longitude: 127.888,
        programName: "산나물채취체험",
        programContent: "농작물경작체험",
        imageUrl: "https://picsum.photos/800/600?random=21",
    },
    {
        villageId: 12,
        villageName: "어촌체험마을",
        sidoName: "경상남도",
        sigunguName: "통영시",
        address: "경상남도 통영시 어항길 567",
        phoneNumber: "055-234-5678",
        latitude: 34.854,
        longitude: 128.433,
        programName: "어촌체험",
        programContent: "자연생태체험",
        imageUrl: "https://picsum.photos/800/600?random=22",
    },
    {
        villageId: 13,
        villageName: "고택마을",
        sidoName: "경상북도",
        sigunguName: "안동시",
        address: "경상북도 안동시 고택길 890",
        phoneNumber: "054-345-6789",
        latitude: 36.568,
        longitude: 128.729,
        programName: "양반문화체험",
        programContent: "전통문화체험",
        imageUrl: "https://picsum.photos/800/600?random=23",
    },
    {
        villageId: 14,
        villageName: "발효음식마을",
        sidoName: "전라남도",
        sigunguName: "순천시",
        address: "전라남도 순천시 발효길 123",
        phoneNumber: "061-456-7890",
        latitude: 34.950,
        longitude: 127.487,
        programName: "장담그기체험",
        programContent: "만들기체험",
        imageUrl: "https://picsum.photos/800/600?random=24",
    },
    {
        villageId: 15,
        villageName: "목공예마을",
        sidoName: "충청남도",
        sigunguName: "공주시",
        address: "충청남도 공주시 목공예길 456",
        phoneNumber: "041-567-8901",
        latitude: 36.445,
        longitude: 127.119,
        programName: "맥가이버목공예프로그램",
        programContent: "만들기체험",
        imageUrl: "https://picsum.photos/800/600?random=25",
    },
    {
        villageId: 16,
        villageName: "들꽃마을",
        sidoName: "경기도",
        sigunguName: "양평군",
        address: "경기도 양평군 들꽃길 789",
        phoneNumber: "031-678-9012",
        latitude: 37.491,
        longitude: 127.487,
        programName: "야생화가꾸기",
        programContent: "농작물경작체험",
        imageUrl: "https://picsum.photos/800/600?random=26",
    },
    {
        villageId: 17,
        villageName: "전통주마을",
        sidoName: "경상북도",
        sigunguName: "경주시",
        address: "경상북도 경주시 전통주길 234",
        phoneNumber: "054-789-0123",
        latitude: 35.856,
        longitude: 129.224,
        programName: "전통주빚기",
        programContent: "만들기체험",
        imageUrl: "https://picsum.photos/800/600?random=27",
    },
    {
        villageId: 18,
        villageName: "곶감마을",
        sidoName: "경상남도",
        sigunguName: "산청군",
        address: "경상남도 산청군 곶감로 567",
        phoneNumber: "055-890-1234",
        latitude: 35.415,
        longitude: 127.873,
        programName: "곶감만들기체험",
        programContent: "농작물경작체험",
        imageUrl: "https://picsum.photos/800/600?random=28",
    },
    {
        villageId: 19,
        villageName: "숲속마을",
        sidoName: "강원도",
        sigunguName: "인제군",
        address: "강원도 인제군 숲길 890",
        phoneNumber: "033-901-2345",
        latitude: 38.069,
        longitude: 128.170,
        programName: "숲치유프로그램",
        programContent: "건강",
        imageUrl: "https://picsum.photos/800/600?random=29",
    },
    {
        villageId: 20,
        villageName: "민박마을",
        sidoName: "제주특별자치도",
        sigunguName: "제주시",
        address: "제주특별자치도 제주시 민박길 123",
        phoneNumber: "064-012-3456",
        latitude: 33.499,
        longitude: 126.531,
        programName: "제주전통가옥체험",
        programContent: "전통문화체험",
        imageUrl: "https://picsum.photos/800/600?random=30",
    },
    {
        villageId: 21,
        villageName: "민박마을",
        sidoName: "제주특별자치도",
        sigunguName: "제주시",
        address: "제주특별자치도 제주시 민박길 123",
        phoneNumber: "064-012-3456",
        latitude: 33.499,
        longitude: 126.531,
        programName: "가죽공예",
        programContent: "만들기체험",
        imageUrl: "https://picsum.photos/800/600?random=31",
    },
];

// Users data
export const users = [
    {
        userId: 1,
        username: "traveler123",
        password: "password123",
        email: "traveler@example.com",
        createdAt: "2025-01-01T00:00:00",
    },
];

// Collections data
export const initialCollections = [
    {
        collectionId: 1,
        userId: 1,
        villageId: 12,
        collectedAt: "2025-11-15T10:30:00",
    },
    {
        collectionId: 2,
        userId: 1,
        villageId: 9,
        collectedAt: "2025-11-16T14:20:00",
    },
    {
        collectionId: 3,
        userId: 1,
        villageId: 13,
        collectedAt: "2025-11-17T09:15:00",
    },
    {
        collectionId: 4,
        userId: 1,
        villageId: 19,
        collectedAt: "2025-11-18T16:45:00",
    },
    {
        collectionId: 5,
        userId: 1,
        villageId: 20,
        collectedAt: "2025-11-19T11:30:00",
    },
];

// Memories data
export const initialMemories = [
    {
        memoryId: 2,
        userId: 1,
        villageId: 9,
        villageName: "DMZ생태마을",
        sidoName: "경기도",
        sigunguName: "파주시",
        address: "경기도 파주시 DMZ로 678",
        imageUrl: "https://picsum.photos/800/600?random=1",
        content: "DMZ 생태 탐방이 정말 인상 깊었습니다. 자연과 평화의 소중함을 느낄 수 있었어요.",
        visitDate: "2025-11-10",
        createdAt: "2025-11-10T14:30:00",
        updatedAt: "2025-11-10T14:30:00",
    },
    {
        memoryId: 4,
        userId: 1,
        villageId: 19,
        villageName: "숲속마을",
        sidoName: "강원도",
        sigunguName: "인제군",
        address: "강원도 인제군 숲길 890",
        imageUrl: "https://picsum.photos/800/600?random=2",
        content: "숲 치유 프로그램을 통해 마음의 평화를 찾았습니다. 힐링이 필요한 분들께 강력 추천!",
        visitDate: "2025-11-15",
        createdAt: "2025-11-15T10:20:00",
        updatedAt: "2025-11-15T10:20:00",
    },
    {
        memoryId: 5,
        userId: 1,
        villageId: 20,
        villageName: "민박마을",
        sidoName: "제주특별자치도",
        sigunguName: "제주시",
        address: "제주특별자치도 제주시 민박길 123",
        imageUrl: null,
        content: "제주 전통 가옥에서의 하루밤이 특별한 추억이 되었어요.",
        visitDate: "2025-11-18",
        createdAt: "2025-11-18T16:45:00",
        updatedAt: "2025-11-18T16:45:00",
    },
];

// Gacha history data
export const initialGachaHistory = [];
